import { APICore } from './apiCore'

const api = new APICore()

function getCategorias (params) {
  const baseUrl = '/categorias'
  return api.get(baseUrl, params)
}

function getCategoria (id) {
  const baseUrl = `/categorias/${id}`
  return api.get(baseUrl, {})
}

function addCategoria (params) {
  const baseUrl = '/categorias'
  return api.create(baseUrl, params)
}

function updateCategoria (params) {
  const baseUrl = '/categorias'
  return api.update(baseUrl, params)
}

function deleteCategoria (params) {
  const baseUrl = '/categorias'
  return api.delete(baseUrl, params)
}

export { getCategorias, getCategoria, addCategoria, updateCategoria, deleteCategoria }
